var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.2,
    stroke: "#C4C2F4",
    strokeWidth: 1.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.293 11.2931C16.6835 10.9026 17.3165 10.9026 17.707 11.2931L20.707 14.2931C21.0975 14.6837 21.0975 15.3167 20.707 15.7072L17.707 18.7072C17.3165 19.0976 16.6835 19.0976 16.293 18.7072C15.9025 18.3167 15.9025 17.6837 16.293 17.2931L17.5859 16.0002H10C9.44772 16.0002 9 15.5525 9 15.0002C9 14.4479 9.44772 14.0002 10 14.0002H17.5859L16.293 12.7072C15.9025 12.3167 15.9025 11.6837 16.293 11.2931Z",
    fill: "#C4C2F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse);
export default __webpack_public_path__ + "static/media/ellipse.830a140dc072469da7122ffb47924765.svg";
export { ForwardRef as ReactComponent };